
import AV from "leancloud-storage";
import { User } from "@/models";
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: "SignUp",
async created() {
this.from = this.$route.query.from;
},
mounted() {
},
props: [],
data() {
return {
from: "",
phone: ""
};
},
metaInfo() {
return {
title: "注册"
};
},
methods: {
async requestSmsCode() {
if (!this.phone) {
this.$vux.toast.text("手机号不能为空", "middle");
return;
}

let phoneString = this.phone.toString()
if (phoneString.length != 11) {
this.$vux.toast.text("无效的手机号", "middle");
return;
}

try {
let exist = await User.checkPhoneExist(phoneString)
if (exist) {
this.$vux.toast.text("该手机号已被注册", "middle");
return
}
} catch (err) {
this.$vux.toast.text(`操作失败: ${err.message}`, "middle");
return
}

try {
var captcha = new TencentCaptcha('198762067', async (res) => {
console.log(res)

let ticket = res.ticket
let randstr = res.randstr

try {
await AV.Cloud.run(
"sendSMSCodeViaTencentCloudCaptchaVerification",
{ ticket, randstr, mobilePhone: phoneString, client: "web", action: "signUp" }
)
} catch (err) {
this.$vux.toast.text("图形码验证失败", "middle");
return
}

this.$vux.toast.show({
text: "验证码发送成功，请查收短信",
position: "middle",
onHide: () => {
this.$router.push({
name: "signUpVerifyPhone",
query: { phone: this.phone, from: this.from }
});
}
});
})
captcha.show()
} catch (err) {
console.log(err)
}
}
},

components: {
XInput,
Group,
XButton
}
};



// WEBPACK FOOTER //
// ./src/pages/account/SignUp.vue